import { defineMessages } from 'react-intl-next';

export default defineMessages({
	poweredBy: {
		id: 'project-pages.improvement.powered-by',
		defaultMessage: 'Powered by',
		description:
			'Prefix to the footer indicating the Project pages feature is powered by Confluence',
	},
	poweredByTooltip: {
		id: 'project-pages.improvement.powered-by.tooltip',
		defaultMessage: 'Open Confluence in a new tab',
		description:
			'Tooltip on the Confluence logo in the powered by footer to indicate that clicking will open Confluence in a new tab',
	},
});
